// Template Generated by DataExtraction.py at 1716507313

import EnglishReg3 from "../../Forms/KYC2/English_Reg-3.png";
import EnglishReg3Labels from "../../Labels/KYC2/English_Reg-3.json";
import FrenchReg3 from "../../Forms/KYC2/French_Reg-3.png";
import FrenchReg3Labels from "../../Labels/KYC2/French_Reg-3.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    drawWhiteBox,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab,
    formatDayFromDate,
    formatMonthFromDate,
    formatYearFromDate,
    drawText as drawTextAtPos,
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import moment from "moment/moment";
import { t } from "i18next";
import { displayCurrency } from "../../../Utils/FormattingUtils";
import {
    calculateTotalInvestmentAssets,
    calculateTotalOtherAssets,
} from "../../../Utils/KYCUtils";
import {
    PLAN_TYPE_IDS,
    calculateLifetimeDepositAmount,
    calculateYearlyDepositAmount,
} from "../../../Utils/PlanUtils";

const HIDE_GROUP_BOX = { x: 16.46, y: 9.99, width: 174.68, height: 65 };
const HIDE_ACHIEVERS_BOX = {
    x: 16.46,
    y: 72.99,
    width: 174.68,
    height: 69.55,
};
const HIDE_SI_BOX = { x: 16.46, y: 141.99, width: 174.68, height: 71.55 };

const HIDE_GROUP_CONTRIBUTIONS = { x: 16.46, y: 58.4, width: 174.68, height: 16.55 }
const HIDE_SI_CONTRIBUTIONS = { x: 16.46, y: 194.99, width: 174.68, height: 20.55 };
const HIDE_ACHIEVERS_CONTRIBUTIONS = {
    x: 16.46,
    y: 126.49,
    width: 174.68,
    height: 17.55,
};

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? FrenchReg3Labels : EnglishReg3Labels;
    const formImage = isFrench ? FrenchReg3 : EnglishReg3;

    function fillCheckbox(value, label) {
        drawTextOnLabel(doc, value ? t("Yes") : t("No"), label, labels);
    }

    function drawText(value, label, colorOverride = null, bold = false) {
        drawTextOnLabel(doc, value, label, labels, colorOverride, bold);
    }

    function drawLongText(value, label) {
        drawTextOnLabel(doc, value, label, labels, null, false, true);
    }

    // add image
    doc.addImage(
        formImage,
        standardFormFormat,
        labels["image"]["x"],
        labels["image"]["y"],
        labels["image"]["width"],
        labels["image"]["height"],
        null,
        standardFormCompression,
    );

    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;
    const common = data.common;
    const kyc = data.knowYourClient;
    const plan = data.plan;

    const liquidAssets = Number(kyc.cashAndLiquid) || 0;
    const investableAssets = calculateTotalInvestmentAssets(kyc) || 0;
    const illiquidAssets = calculateTotalOtherAssets(kyc) || 0;

    let contribution =
        plan.depositMode === "T"
            ? calculateLifetimeDepositAmount(data, true, true)
            : calculateYearlyDepositAmount(data, true, true);
    contribution = Number(contribution) || 0;

    const formatPct = (contribution, assets) => {
        if (!contribution || !assets) return "0.00%";
        return ((Number(contribution) / assets) * 100).toFixed(2) + "%";
    };

    // TODO: Review exact names of the KYC properties for KYC2.
    // Making best-guess approximations based on JSON label names.
    drawText(kyc.riskProfileConclusion || "", "riskProfileConclusion");
    drawLongText(kyc.whyPlanIsSuitable || "", "whyPlanIsSuitable");
    drawLongText(kyc.notes || "", "notes");

    // TODO: check afterwards if these label mappings are correct
    if (plan.planTypeID === 0) {
        // Group
        fillCheckbox(
            kyc.groupRecommendationConsiderObjectivesAndTime,
            "groupRecommendationConsiderObjectivesAndTime",
        );
        fillCheckbox(
            kyc.groupAbilityToMeetRequirements,
            "groupAbilityToMeetRequirements",
        );
        fillCheckbox(kyc.groupReviewedFees, "groupReviewedFees");
        fillCheckbox(kyc.groupConsideredAchievers, "groupConsideredAchievers");
        fillCheckbox(kyc.groupConsideredSI, "groupConsideredSI");
        fillCheckbox(
            kyc.groupRecommendationConsidersRisk,
            "groupRecommendationConsidersRisk",
        );
        fillCheckbox(
            kyc.groupConfirmedAbilityToMeetContributions,
            "groupConfirmedAbilityToMeetContributions",
        );
        fillCheckbox(
            kyc.groupConfirmedWillingness,
            "groupConfirmedWillingness",
        );
        drawLongText(
            kyc.groupAlternativeNotSelectedDescription || "",
            "groupAlternativeNotSelectedDescription",
        );
        drawLongText(
            kyc.groupWhyPutsInterestFirst || "",
            "groupWhyPutsInterestFirst",
        );
        // drawText(plan.depositMode || "", "SIPlanMode");
        // drawText(
        //     plan.depositMode === "T"
        //         ? displayCurrency(contribution, i18n.language)
        //         : "",
        //     "groupTModeContribution",
        // );
        // drawText(
        //     formatPct(contribution, illiquidAssets),
        //     "groupContributionAsPercentOfIlliquid",
        // );
        // drawText(
        //     formatPct(contribution, investableAssets),
        //     "groupContributionAsPercentOfInvestable",
        // );
        // drawText(
        //     plan.depositMode !== "T"
        //         ? displayCurrency(contribution, i18n.language)
        //         : "",
        //     "groupOtherModesAnnualContribution",
        // );
        // drawText(
        //     formatPct(contribution, liquidAssets),
        //     "groupContributionAsPercentOfLiquid",
        // );
    } else if (plan.planTypeID === 1) {
        // SI
        fillCheckbox(
            kyc.SIRecommendationConsiderObjectivesAndTime,
            "SIRecommendationConsiderObjectivesAndTime",
        );
        fillCheckbox(kyc.SIReviewedFees, "SIReviewedFees");
        fillCheckbox(
            kyc.SIRecommendationConsidersRisk,
            "SIRecommendationConsidersRisk",
        );
        fillCheckbox(kyc.SINeedForFlexibility, "SINeedForFlexibility");
        fillCheckbox(kyc.SIConfirmedWillingness, "SIConfirmedWillingness");
        drawLongText(
            kyc.SIAlternativeNotSelectedDescription || "",
            "SIAlternativeNotSelectedDescription",
        );
        fillCheckbox(kyc.SIConsideredGroup, "SIConsideredGroup");
        fillCheckbox(kyc.SIConsideredAchievers, "SIConsideredAchievers");
        drawLongText(
            kyc.SIWhyPutsInterestFirst || "",
            "SIWhyPutsInterestFirst",
        );
        // drawText(plan.depositMode || "", "SIPlanMode");
        // drawText(
        //     plan.depositMode === "T"
        //         ? displayCurrency(contribution, i18n.language)
        //         : "",
        //     "SITModeContribution",
        // );
        // drawText(
        //     formatPct(contribution, illiquidAssets),
        //     "SIContributionAsPercentOfIlliquid",
        // );
        // drawText(
        //     formatPct(contribution, investableAssets),
        //     "SIContributionAsPercentOfInvestable",
        // );
        // drawText(
        //     plan.depositMode !== "T"
        //         ? displayCurrency(contribution, i18n.language)
        //         : "",
        //     "SIOtherModesAnnualContribution",
        // );
        // drawText(
        //     formatPct(contribution, liquidAssets),
        //     "SIContributionAsPercentOfLiquid",
        // );
    } else if (plan.planTypeID === 2) {
        // Achievers
        fillCheckbox(
            kyc.achieversRecommendationConsiderObjectivesAndTime,
            "achieversRecommendationConsiderObjectivesAndTime",
        );
        fillCheckbox(
            kyc.achieversConfirmedReasonablenessOfContribution,
            "achieversConfirmedReasonablenessOfContribution",
        );
        fillCheckbox(kyc.achieversReviewedFees, "achieversReviewedFees");
        fillCheckbox(kyc.achieversConsideredGroup, "achieversConsideredGroup");
        fillCheckbox(kyc.achieversConsideredSI, "achieversConsideredSI");
        fillCheckbox(
            kyc.achieversRecommendationConsidersRisk,
            "achieversRecommendationConsidersRisk",
        );
        fillCheckbox(
            kyc.achieversConfirmedWillingness,
            "achieversConfirmedWillingness",
        );
        drawLongText(
            kyc.achieversAlternativeNotSelectedDescription || "",
            "achieversAlternativeNotSelectedDescription",
        );
        drawLongText(
            kyc.achieversWhyPutsInterestFirst || "",
            "achieversWhyPutsInterestFirst",
        );
        // drawText(plan.depositMode || "", "achieversPlanMode");
        // drawText(
        //     plan.depositMode === "T"
        //         ? displayCurrency(contribution, i18n.language)
        //         : "",
        //     "achieversTModeContribution",
        // );
        // drawText(
        //     formatPct(contribution, illiquidAssets),
        //     "achieversContributionAsPercentOfIlliquid",
        // );
        // drawText(
        //     formatPct(contribution, investableAssets),
        //     "achieversContributionAsPercentOfInvestable",
        // );
        // drawText(
        //     plan.depositMode !== "T"
        //         ? displayCurrency(contribution, i18n.language)
        //         : "",
        //     "achieversOtherModesAnnualContribution",
        // );
        // drawText(
        //     formatPct(contribution, liquidAssets),
        //     "achieversContributionAsPercentOfLiquid",
        // );
        fillCheckbox(
            kyc.achieversNeedForFlexibility,
            "achieversNeedForFlexibility",
        );
    }

    let hide_achievers_box = HIDE_ACHIEVERS_BOX;
    let hide_achievers_contributions = HIDE_ACHIEVERS_CONTRIBUTIONS;

    let hide_SI_box = HIDE_SI_BOX;
    let hide_SI_contributions = HIDE_SI_CONTRIBUTIONS;

    let hide_group_box = HIDE_GROUP_BOX;
    let hide_group_contributions = HIDE_GROUP_CONTRIBUTIONS;




    drawWhiteBox(
        doc,
        hide_achievers_contributions.x,
        hide_achievers_contributions.y,
        hide_achievers_contributions.width,
        hide_achievers_contributions.height,
    );

    drawWhiteBox(
        doc,
        hide_SI_contributions.x,
        hide_SI_contributions.y,
        hide_SI_contributions.width,
        hide_SI_contributions.height,
    );

    drawWhiteBox(
        doc,
        hide_group_contributions.x,
        hide_group_contributions.y,
        hide_group_contributions.width,
        hide_group_contributions.height,
    );

    // Keep only the selected plan section visible.
    if (plan.planTypeID === PLAN_TYPE_IDS.GROUP) {
        drawWhiteBox(
            doc,
            hide_achievers_box.x,
            hide_achievers_box.y,
            hide_achievers_box.width,
            hide_achievers_box.height,
        );
        drawWhiteBox(
            doc,
            hide_SI_box.x,
            hide_SI_box.y,
            hide_SI_box.width,
            hide_SI_box.height,
        );
    } else if (plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
        drawWhiteBox(
            doc,
            hide_group_box.x,
            hide_group_box.y,
            hide_group_box.width,
            hide_group_box.height,
        );
        drawWhiteBox(
            doc,
            hide_SI_box.x,
            hide_SI_box.y,
            hide_SI_box.width,
            hide_SI_box.height,
        );
    } else if (plan.planTypeID === PLAN_TYPE_IDS.SI) {
        drawWhiteBox(
            doc,
            hide_group_box.x,
            hide_group_box.y,
            hide_group_box.width,
            hide_group_box.height,
        );
        drawWhiteBox(
            doc,
            hide_achievers_box.x,
            hide_achievers_box.y,
            hide_achievers_box.width,
            hide_achievers_box.height,
        );
    }
};

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    // English_Reg-3.json has an empty signatures dictionary, so returning empty array.
    let signers = [];
    return signers;
};

export default {
    generate,
    signatureDefinitions,
};
